<!--站点设置-->
<template>
  <div class="main" :style="{height: tableHeight + 'px'}">
    <el-form ref="formRef" :model="form" :rules="rules" label-width="130px">
      <el-input v-model="form.id" type="hidden"></el-input>
      <el-form-item label="系统名称" prop="appName">
          <el-input v-model="form.appName" maxlength="50" show-word-limit class="width4"></el-input>
      </el-form-item>
      <el-form-item label="系统版本" prop="appVersion">
        <el-input v-model="form.appVersion" maxlength="50" class="width"></el-input>
      </el-form-item>
      <el-form-item label="系统描述" prop="appDesc">
        <el-input v-model="form.appDesc " type="textarea" rows=4 maxlength="1000" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="系统logo" prop="appLogoUrl">
          <el-input v-model="form.appLogoUrl" class="width4"></el-input>
      </el-form-item>
      <el-form-item label="版权信息" prop="appCopyright">
        <el-input v-model="form.appCopyright" type="textarea" rows=2 maxlength="200" show-word-limit></el-input>
      </el-form-item>
     <el-form-item label="列表每页">
        <el-input-number v-model="form.appPageSize" :min="0" />
      </el-form-item>
      <el-form-item label="站点文本" prop="appText">
          <el-input v-model="form.appText" type="textarea" rows=3 maxlength="200" show-word-limit></el-input>
      </el-form-item>
      <div class="main-footer">
        <el-button @click="resetForm">重 填</el-button>
        <el-button type="primary" @click="saveInfo">确 定</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'siteset',
  data () {
    return {
      tableHeight: 0,
      form: {
        id: '',
        appName: '',
        appVersion: '',
        appDesc: '',
        appLogoUrl: '',
        appCopyright: '',
        appPageSize: 10,
        appText: ''
      },
      rules: {
        appName: [
          { required: true, message: '请输入应用系统名称', trigger: 'blur' },
          { min: 3, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  // 接收父组件传值
  props: ['clientHeight'],
  mounted () {
    // console.log('configQX=', this.$route.params.qx)
    this.getTableHeight()
    this.editInfo()
  },
  methods: {
    async editInfo () {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const { data: ret } = await this.$http.get(this.$api.config)
      if (ret.status === 0 && ret.data !== null) {
        this.siteFolderDisabled = true
        const obj = ret.data
        Object.keys(this.form).forEach(key => {
          this.form[key] = obj[key]
        })
      } else {
        this.$message.error(ret.message)
      }
      loading.close()
    },
    saveInfo () {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          const { data: ret } = await this.$http.post(this.$api.configsave, this.form)
          if (ret.status === 0) {
            this.$message.success(ret.message)
          } else {
            this.$message.error(ret.message)
          }
          loading.close()
        } else {
          this.$message.error('验证没通过。')
          return false
        }
      })
    },
    resetForm () {
      this.$refs.formRef.resetFields()
    },
    getTableHeight () {
      this.tableHeight = this.clientHeight - 50
    }
  },
  watch: {
    clientHeight: function (val) {
      this.getTableHeight()
    }
  }
}
</script>

<style lang="less" scoped>
.main{
  width: 100%;
  /* 设置出现滚动条 */
  overflow: auto;
  // border: solid 1px #666;
  .el-form {
    padding: 10px 60px 30px 0;
  }
  .main-footer{
    text-align: right;
  }
}
</style>
